import { LayoutGrid } from "lucide-react";
import { scrollToId } from "./Navbar";

const LINKS = [
    { label: "Home", href: "#top", testid: "footer-link-home" },
    { label: "Chatbot", href: "#chatbot", testid: "footer-link-chatbot" },
    { label: "Floor Plans", href: "#floor-plans", testid: "footer-link-floor-plans" },
    { label: "Contact", href: "#contact", testid: "footer-link-contact" },
];

export function Footer() {
    return (
        <footer data-testid="footer" className="border-t border-[var(--line)] bg-[var(--bg)]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
                    <a href="#top" onClick={(e) => scrollToId(e, "#top")} data-testid="footer-logo-link" className="flex items-center gap-2.5 min-h-[44px]">
                        <span className="w-7 h-7 rounded-md bg-[var(--accent)] text-[#0A0908] grid place-items-center">
                            <LayoutGrid size={15} strokeWidth={2.2} />
                        </span>
                        <span className="font-display font-bold text-[var(--ink)]">IDeaSpace</span>
                        <span className="text-sm text-[var(--ink-3)]">· IDeaS India, Pune</span>
                    </a>

                    <nav className="flex flex-wrap gap-x-6 gap-y-2">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={l.testid}
                                onClick={(e) => scrollToId(e, l.href)}
                                className="min-h-[44px] inline-flex items-center text-sm font-medium text-[var(--ink-2)] hover:text-[var(--accent)] transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>

                    <p className="text-sm text-[var(--ink-3)] italic">Office operations, simplified.</p>
                </div>

                <div className="mt-10 pt-6 border-t border-[var(--line)] flex flex-col sm:flex-row justify-between gap-2">
                    <p className="mono text-[11px] tracking-[0.14em] text-[var(--ink-3)] uppercase">
                        © 2026 IDeaSpace · Internal platform · IDeaS India
                    </p>
                    <p className="mono text-[11px] tracking-[0.14em] text-[var(--ink-3)] uppercase">
                        18.5204° N, 73.8567° E
                    </p>
                </div>
            </div>
        </footer>
    );
}
